// BARRA DELL'APP — l'unica cosa che sta sopra la web app dopo l'accesso.
//
// Nell'area riservata non compaiono piu' menu di prodotto, prezzi, conformita' o pagine
// informative: dentro Lattice si vede Lattice. Resta un solo tasto per tornare al sito
// pubblico, dove tutte quelle informazioni continuano a esistere.
import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "@/lib/nav";
import { Home, LogOut, Hexagon } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { sessionState } from "@/lib/weblock";
import { useAppVersion, useNetworkVersion, CODENAME } from "@/lib/version";
import SpiaRete from "@/components/app/SpiaRete";

export default function AppBar() {
  const ver = useAppVersion();
  const rete = useNetworkVersion();
  const { user, logout } = useAuth();
  const nav = useNavigate();
  // Lo stato del lucchetto cambia DOPO il primo disegno (il PIN si inserisce dopo):
  // senza questo ascolto, aprendo la sessione di copertura l'indirizzo reale resterebbe
  // a schermo — cioè l'unica prova che il doppio fondo esiste.
  const [gate, setGate] = useState(() => sessionState());
  useEffect(() => {
    const on = () => setGate(sessionState());
    window.addEventListener("lattice:lock", on);
    return () => window.removeEventListener("lattice:lock", on);
  }, []);

  return (
    <header className="sticky top-0 z-50 border-b lt-glass" style={{ borderColor: "var(--lt-border)" }} data-testid="app-bar">
      <div className="mx-auto flex h-16 max-w-[1600px] items-center gap-4 px-4 lg:px-8">
        <Link to="/app" className="flex items-center gap-3" data-testid="app-bar-logo">
          <Hexagon className="h-6 w-6 lp-c" strokeWidth={1} />
          <span className="flex flex-col leading-none">
            <span className="font-display text-base font-semibold tracking-tight text-white">LATTICE</span>
            <span className="mt-0.5 font-mono text-[8px] uppercase tracking-[0.18em] text-[#565c59]">{(rete ? "rete v" + rete + " · app v" + ver : "v" + ver) + " · " + CODENAME}</span>
          </span>
        </Link>

        {/* NEGAZIONE PLAUSIBILE: nella sessione di copertura l'indirizzo reale non si
            vede. Mostrarlo renderebbe inutile il doppio PIN: è l'unica prova che serve
            a chi ti sta guardando sblocare il PC. */}
        <span className="ml-auto hidden truncate font-mono text-[10px] uppercase tracking-[0.2em] text-[#565c59] sm:block" data-testid="app-bar-lns">
          {gate === "decoy" ? "" : user?.lns}
        </span>

        {/* Come stai viaggiando: nodo, protocollo, ritardo. Dice la verità anche quando
            la verità è "traffico in chiaro": il tunnel mimetizzato vive solo nell'app. */}
        <SpiaRete />

        <Link to="/" data-testid="app-bar-home"
          className="inline-flex items-center gap-2 border px-4 py-2 font-mono text-[10px] uppercase tracking-[0.18em] text-[#c8cfcb] transition-colors lp-h-bd hover:text-white"
          style={{ borderColor: "var(--lt-border)" }}>
          <Home className="h-3.5 w-3.5" strokeWidth={1} /> Home
        </Link>

        <button onClick={() => { logout(); nav("/"); }} data-testid="app-bar-logout"
          className="inline-flex items-center gap-2 border px-4 py-2 font-mono text-[10px] uppercase tracking-[0.18em] text-[#8d9591] transition-colors hover:border-[#ff3333]/50 hover:text-[#ff5b5b]"
          style={{ borderColor: "var(--lt-border)" }}>
          <LogOut className="h-3.5 w-3.5" strokeWidth={1} />
        </button>
      </div>
    </header>
  );
}
